import React, { memo } from 'react'
import { TimeLineContentWrapper, TimeLineContentHeaderWrapper } from '../../../styles/styles'
import { ActivityPayment } from '../../../types/types'
import TimelineItemHeader from '../activity-timeline-item-header/activity-timeline-item-header'
import { TimelineItemProps } from '../activity-timeline-Item'
import { ModalEditPayment } from '../modals/edit-payment'

function formatCurrency(value?: string | number) {
  return (Number(value) || 0)
    .toLocaleString('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      currencyDisplay: 'symbol',
    })
    .replace('₽', '')
}

type ActivityTimelinePaymentType = Omit<TimelineItemProps, 'data'>

interface ActivityTimelinePaymentProps extends ActivityTimelinePaymentType {
  className?: string
  data?: ActivityPayment
}

const ActivityTimelinePayment: React.FC<ActivityTimelinePaymentProps> = memo(
  (props: ActivityTimelinePaymentProps) => {
    const { date, data } = props
    const title = data?.changed ? 'Оплата (изменено)' : 'Оплата'
    const showChangeButton = data?.editable

    return (
      <TimeLineContentWrapper>
        <TimeLineContentHeaderWrapper>
          <TimelineItemHeader date={date} title={title} />
          {showChangeButton ? (
            <ModalEditPayment sum={data?.sum} date={date} paymentId={data?.id} />
          ) : null}
        </TimeLineContentHeaderWrapper>
        <div>
          Внесена предоплата в размере <b>{formatCurrency(data?.sum)} руб.</b>. Задолженность:{' '}
          <b>{formatCurrency(data?.debt)} руб.</b>
        </div>
      </TimeLineContentWrapper>
    )
  },
)

ActivityTimelinePayment.displayName = 'ActivityTimelinePayment'
export default ActivityTimelinePayment
